import React, { createContext, useContext, useState, useCallback } from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';

const NotificationContext = createContext();

export function NotificationProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const push = useCallback(({
    variant = 'danger',          // 'success' | 'warning' | …
    title   = 'Error',
    message = '',
    delay   = 5000
  }) => {
    const id = Date.now();
    setToasts(t => [...t, { id, variant, title, message, delay }]);
  }, []);

  const remove = id => setToasts(t => t.filter(x => x.id !== id));

  return (
    <NotificationContext.Provider value={{ push }}>
      {children}

      {/* toast viewport (bottom-right) */}
      <ToastContainer position="bottom-end" className="p-3">
        {toasts.map(t => (
          <Toast
            key={t.id}
            bg={t.variant}
            onClose={() => remove(t.id)}
            delay={t.delay}
            autohide
          >
            <Toast.Header closeButton={false}>
              <strong className="me-auto text-white">{t.title}</strong>
            </Toast.Header>
            <Toast.Body className="text-white">{t.message}</Toast.Body>
          </Toast>
        ))}
      </ToastContainer>
    </NotificationContext.Provider>
  );
}

export const useNotify = () => useContext(NotificationContext);
